'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';
import moment from 'moment';

class OnOfflineStore {
  @observable start = moment();
  @observable end = moment();
  @observable formatData = [];
  @observable originData = [];

  @action
  changeDate = dates => {
    this.start = dates[0];
    this.end = dates[1];
  };

  @action
  getOnlineLogs = deviceId => {
    const params = buildUrl({
      deviceId,
      start: this.start.startOf('day').valueOf(),
      end: this.end.endOf('day').valueOf()
    });
    const total =
      this.end.endOf('day').valueOf() - this.start.startOf('day').valueOf();
    fetch(`/api/device/online-logs${params}`, { method: 'GET' }, json => {
      if (!json.length) {
        this.formatData = [];
        this.originData = [];
      } else {
        this.originData = json;

        const data = [...json];
        const first = data[0];
        const last = data[data.length - 1];
        /**
         * 这里先补充后端接口逻辑，后端会尝试往前往后各找一个点，如果找到了就把这个点塞进List，找不到就不加进去
         * 前端也要对应做处理，首先看一下收尾两个点在不在查询范围内，如果不在，把updateTime改成查询范围两端就行，否则，需要补充
         * 如果起始端点缺了，说明前面真没数据，补充null
         * 如果终止端点缺了，需要看是不是今天（前端禁止查未来），如果是今天，当前时间之前都视为最后一个状态，之后视为无数据；如果不是今天，那么后面的一段都视为前一个状态的延续
         */
        if (moment(first.updateTime).isBefore(this.start.startOf('day'))) {
          first.updateTime = moment(this.start.startOf('day')).format(
            'YYYY-MM-DD HH:mm:ss'
          );
        } else if (
          moment(first.updateTime).isAfter(this.start.startOf('day'))
        ) {
          data.unshift({
            id: null,
            deviceId,
            onlineStatus: null,
            updateTime: moment(this.start.startOf('day')).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          });
        }
        if (moment(last.updateTime).isAfter(this.end.endOf('day'))) {
          last.updateTime = moment(this.end.endOf('day')).format(
            'YYYY-MM-DD HH:mm:ss'
          );
        } else if (moment(last.updateTime).isBefore(this.end.endOf('day'))) {
          if (this.end.isSame(moment(), 'day')) {
            data.push({
              id: null,
              deviceId,
              onlineStatus: null,
              updateTime: moment().format('YYYY-MM-DD HH:mm:ss')
            });
            data.push({
              id: null,
              deviceId,
              onlineStatus: null,
              updateTime: this.end.endOf('day').format('YYYY-MM-DD HH:mm:ss')
            });
          } else {
            data.push({
              id: null,
              deviceId,
              onlineStatus: null,
              updateTime: this.end.endOf('day').format('YYYY-MM-DD HH:mm:ss')
            });
          }
        }
        const result = data
          .reduce((prev, current) => {
            // 第一个直接塞进去
            if (!prev.length) {
              prev.push({
                onlineStatus: current.onlineStatus,
                items: [current.updateTime]
              });
              return prev;
            }
            // 后面的需要先和前面的对比状态，不管状态一不一致都需要把时间塞到前一个里面，如果不一致需要新增一个
            const last = prev[prev.length - 1];
            last.items.push(current.updateTime);
            if (current.onlineStatus !== last.onlineStatus) {
              prev.push({
                onlineStatus: current.onlineStatus,
                items: [current.updateTime]
              });
            }
            return prev;
          }, [])
          .map(i => {
            const start = i.items[0];
            const end = i.items[i.items.length - 1];
            // 计算start,end和百分比percent
            return {
              onlineStatus: i.onlineStatus,
              start,
              end,
              percent:
                (moment(end).valueOf() - moment(start).valueOf()) / total * 100
            };
          });
        this.formatData = result;
      }
    });
  };
}

export default new OnOfflineStore();



// WEBPACK FOOTER //
// ./src/store/DeviceInfo/OnOffline.js